module.exports = __webpack_public_path__ + "static/img/JGArchitecture_网银_image@1x.1354c1af.png";